import React, { useEffect } from "react";
import { connect } from "react-redux";
import { setupNavigation } from "../redux/actions/navItemsActions";
import PropTypes from "prop-types";

function Cookies({ setupNavigation }) {

    const navigationItems =
    {
        sections: [{
            name: 'Admin',
            items: [
                {
                    path: '/about',
                    text: 'About JustGoRide',
                    icon: 'fas fa-info-circle'
                },
                {
                    path: '/about/termsandconditions',
                    text: 'Terms and Conditions',
                    icon: 'fas fa-file-signature'
                },
                {
                    path: '/about/privacypolicy',
                    text: 'Privacy Policy',
                    icon: 'fas fa-user-secret'
                },
                {
                    path: '/about/cookies',
                    text: 'Cookie Policy',
                    icon: 'fas fa-cookie-bite'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Cookie Policy | JustGoRide";
        setupNavigation(navigationItems);

    }, []);

    return (
        <div className="row justify-content-center mt-4">
            <div className="col-10">
                <div className="page-content-head">
                    <h2>How we use Cookies</h2>
                </div>
                <span>Last Updated: 01/03/2020</span>
                <p>
                    A cookie is a small file which is placed on your computer's hard drive. The cookie helps analyse web
                    traffic or lets you know when you visit a particular site. Cookies allow web
                    applications to respond to you as an individual. The web application can tailor
                    its operations to your needs, likes and dislikes by gathering and remembering
                    information about your preferences.
                </p>
                <p>
                    We use traffic log cookies to identify which pages are being used. This helps
                    us analyse data about webpage traffic and improve our website in order to tailor
                    it to customer needs. We only use this information for statistical analysis purposes
                    and then the data is removed from the system.
                </p>
                <p>
                    Overall, cookies help us provide you with a better website, by enabling us to
                    monitor which pages you find useful and which you do not. A cookie in no way gives
                    us access to your computer or any information about you, other than the data you
                    choose to share with us.
                </p>
                <h3>The Cookies in use on JustGoRide</h3>
                <ul>
                    <li>
                        <strong>Session Tracking</strong>
                        <p>This is a fundamental cookie which allows you to sign into JustGoRide.
                        This cookie is created by the framework which this site is built around and
                        is vital for the site to operate</p>
                    </li>
                    <li><
                        strong>Analytics</strong>
                        <p>We use Google Analytics to keep an eye on the site usage to understand trends
                        and to help keep the content of the site relevent to our target market.
                        This is standard practice and will be employeed on many of the sites that you visit.</p>
                    </li>
                    <li>
                        <strong>Personal Preferences</strong>
                        <p>The vast majority of your personal preferences are not stored in cookies but in our database
                        against your user account.
                        The only information we track in cookies is your recently viewed routes so that we can display
                        them back to you on our home page.</p>
                    </li>
                    <li><strong>The Cookie Consent Cookie</strong>
                        <p>Yes when you accept cookies on the site we drop a cookie on your machine to hide the notice.
                        If you clear your cookies the notice will reappear to remind you about this policy!</p>
                    </li>
                </ul>
                <h3>So, In Conclusion..</h3>
                <p>
                    You can choose to accept or decline cookies. Most web browsers automatically accept
                    cookies, but you can usually modify your browser setting to decline cookies if you
                    prefer. If you decline the usage of cookies JustGoRide will no longer function correctly.
                    You will not be able to sign in and take advantage of the site's core features.
                </p>
                <p>
                    <strong>Therefore, by using this site you are agreeing to allow the usage of cookies. </strong>
                </p>
            </div>
        </div>
    );

}

Cookies.propTypes = {
    setupNavigation: PropTypes.func.isRequired
}


function mapStateToProps(state) {
    return {
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(Cookies);   


// WEBPACK FOOTER //
// ./src/components/Cookies.js